export default __webpack_public_path__ + "static/media/CrowdStrike.34c3c2de.jpg";